export const texts = {
  title: {
    de: 'Aufgaben',
    en: 'Tasks'
  },
  empty: {
    de: 'Sie haben keine offenen Aufgaben',
    en: 'You have no open tasks'
  },
  waitingForResponse: {
    de: 'wartet auf Rückmeldung',
    en: 'is waiting for a response'
  },
  yourAssessmentOf: {
    de: 'Deine Einschätzung zu',
    en: 'Your assessment of'
  },
  statusOf: {
    de: 'Wie ist der Status von',
    en: 'What is the status of'
  },
  genderSuffix: {
    de: 'm|w|d',
    en: 'm|f|d'
  }
};
